// extracted by css-extract-rspack-plugin
export default {"root":"oklscj5qBUWceuuV","fade-in":"rLIifqVABS0knAzz","headerStatic":"yU_KkVao27k3ef0x","icon":"Co81wS8mFT4i5CLp","failureIcon":"pfpI3VTeQYoDYPZS","link":"jmxt70uUd8gh6aKn"};